import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from '../../../components/common/Flex';
import SubtleBadge from '../../../components/common/SubtleBadge';
import {
  faTachometerAlt,
  faBook,
  faBell,
  faRoute,
  faPowerOff,
  faCalendarCheck,
  faClock,
  faBan,
  faGasPump,
  faChartPie,
  faSearchLocation, // Usamos este icono para "Buscar punto más cercano"
  faCommentsDollar, // Icono para Reporte de consumo (comentarios y dinero)
  faFileInvoiceDollar, // Icono alternativo para Reporte de consumo (factura y dinero)
  faTemperatureHigh // <-- Agregado para temperatura
} from '@fortawesome/free-solid-svg-icons';

// Mapeo de string a icono real de FontAwesome
const iconMap = {
  'fa-solid fa-gauge': faTachometerAlt, // faGauge no existe, usamos faTachometerAlt
  'fa-solid fa-book': faBook,
  'fa-solid fa-bell': faBell,
  'fa-solid fa-route': faRoute,
  'fa-solid fa-power-off': faPowerOff,
  'fa-solid fa-calendar-check': faCalendarCheck,
  'fa-solid fa-clock': faClock,
  'fa-solid fa-tachometer-alt': faTachometerAlt,
  'fa-solid fa-ban': faBan,
  'fa-solid fa-location-crosshairs': faSearchLocation, // faLocationCrosshairs no existe, usamos faSearchLocation
  'fa-solid fa-gas-pump': faGasPump,
  'fa-solid fa-chart-pie': faChartPie,
  'fa-solid fa-comments-dollar': faCommentsDollar, // Para Reporte de consumo (comentarios y dinero)
  'fa-solid fa-file-invoice-dollar': faFileInvoiceDollar, // Para Reporte de consumo (factura y dinero)
  'fa-solid fa-temperature-high': faTemperatureHigh, // <-- Agregado para temperatura
};

const NavbarVerticalMenuItem = ({ route }) => {
  // Obtiene el icono real si es string, o lo usa directo si es un objeto
  let icon = route.icon;
  if (typeof icon === 'string' && iconMap[icon]) {
    icon = iconMap[icon];
  }
  return (
    <Flex alignItems="center">
      {icon && (
        <span className="nav-link-icon">
          <FontAwesomeIcon icon={icon} />
        </span>
      )}
      <span className="nav-link-text ps-1">{route.name}</span>
      {route.badge && (
        <SubtleBadge pill bg={route.badge.type} className="ms-2">
          {route.badge.text}
        </SubtleBadge>
      )}
    </Flex>
  );
};

// prop-types
const routeShape = {
  active: PropTypes.bool,
  name: PropTypes.string.isRequired,
  to: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};
routeShape.children = PropTypes.arrayOf(PropTypes.shape(routeShape));
NavbarVerticalMenuItem.propTypes = {
  route: PropTypes.shape(routeShape).isRequired
};

export default React.memo(NavbarVerticalMenuItem);
